import styled from 'styled-components';

export const SHyperLink = styled.div`
    cursor: pointer;
    color: blue;
    text-decoration: underline;
    user-select: none;
`;

export const SEvenRow = styled.div`
    display: flex;
    width: 100%;

    & > :nth-child(1) {
        flex: 1;
        display: flex;
        flex-shrink: 0;

        & > :nth-child(1) {
            flex-shrink: 0;
            width: ${(props) => props.labelWidth ?? 180}px;
        }

        & > :nth-child(2) {
            flex-grow: 1;
            padding-left: 5px;
            word-break: break-all;
        }
    }

    & > :nth-child(2) {
        flex: 1;

        display: flex;
        flex-shrink: 0;
        padding-left: 10px;

        & > :nth-child(1) {
            flex-shrink: 0;
            width: ${(props) => props.labelWidth ?? 180}px;
        }

        & > :nth-child(2) {
            flex-grow: 1;
            word-break: break-all;
        }
    }

    & > :nth-child(3) {
        flex: 1;

        display: flex;
        flex-shrink: 0;
        padding-left: 10px;

        & > :nth-child(1) {
            flex-shrink: 0;
            width: ${(props) => props.labelWidth ?? 180}px;
        }

        & > :nth-child(2) {
            flex-grow: 1;
            word-break: break-all;
        }
    }
`;
